import $ from 'jquery';

export default class Header {
    constructor() {
        this.$body = $('body');

        this.activeMenu = false;
        this.hamburgerDuration = 0.2;

        this.$drawer = $('.header__drawer');
        this.$hamburger = $('.header__button');

        this.drawerTimeline = gsap.timeline({ paused: true });
        this.drawerTimeline.to(
            this.$drawer,
            { display: 'initial', left: '0%' },
            0
        )
        this.drawerTimeline.to(
            this.$body,
            { overflow: 'hidden' },
            0
        )

        this.bind();
    }

    bind() {
        this.$hamburger.on("click", this.toggleMenu.bind(this));
    }

    toggleMenu() {
        if(this.activeMenu == false) {
            this.drawerTimeline.play();
            this.$hamburger.addClass('open');
            this.activeMenu = true;
        } else {
            this.drawerTimeline.reverse();
            this.$hamburger.removeClass('open');
            this.activeMenu = false;
        }
    }
}